
export const localStorageNames = {
    showAccessPoints: "showAccessPoints",
    // Superseded by visiblePointOfInterestTypes, still read once to carry over
    // the old all or nothing setting.
    showPointsOfInterest: "showPointsOfInterest",
    visiblePointOfInterestTypes: "visiblePointOfInterestTypes",
    showLegend: "showLegend",
    showTimeSlider: "showTimeSlider",
    useSatelliteBasemap: "useSatelliteBasemap"
}

export const lsTrue = "true"
export const lsFalse = "false"